<ng-container *transloco="let t">
    <mat-nav-list>
        <!--
    Buttons rather than anchors: an <a> with no href is not in the tab order and has
    no interactive semantics, so these were mouse-only. Activation is script-driven
    here, which is what a button is for, and it matches the header's link-buttons.
    -->
        <button
            mat-list-item
            (click)="onSidenavClose(); navigation('provider')"
        >
            <span class="nav-caption">{{
                t("shared.link.find-a-provider") | uppercase
            }}</span>
        </button>
        <button
            mat-list-item
            (click)="onSidenavClose(); navigation('help-and-support')"
        >
            <span class="nav-caption">{{
                t("shared.link.help-and-support") | uppercase
            }}</span>
        </button>
        @if (!isSignedIn) {
        <button mat-list-item (click)="signIn()">
            <span class="nav-caption">{{
                t("shared.link.sign-in") | uppercase
            }}</span>
        </button>
        }
        <!-- Flattened onto the top level: these were behind a menu labelled with the signed-in
    user's name, which read as a heading rather than as something to open, and put two
    ordinary destinations a click further away than the rows around them. -->
        @if (isSignedIn) {
        <button mat-list-item (click)="onSidenavClose(); navigation('account')">
            <span class="nav-caption">{{
                t("shared.link.my-account") | uppercase
            }}</span>
        </button>
        <button mat-list-item (click)="signOut()">
            <span class="nav-caption">{{
                t("shared.link.sign-out") | uppercase
            }}</span>
        </button>
        }
        <!--
    A list row like the three above, so alignment, height, typography and hover all
    come from the same place instead of being reproduced. The contents are laid out
    in a plain flex wrapper rather than Material's matListItemIcon/matListItemMeta
    slots: the meta slot is for text metadata and its typography overrode the icon
    font, rendering `expand_more` as the literal word.
    -->
        <button
            mat-list-item
            [matMenuTriggerFor]="menu"
            class="language-dropdown"
        >
            <span class="language-trigger">
                <span class="nav-caption">{{
                    selectedLanguageName | uppercase
                }}</span>
                <mat-icon>language</mat-icon>
                <mat-icon>expand_more</mat-icon>
            </span>
        </button>
        <mat-menu #menu="matMenu">
            @for (language of languages; track language) {
            <button mat-menu-item (click)="selectLanguage(language.code)">
                {{ language.name }}
            </button>
            }
        </mat-menu>
    </mat-nav-list>
</ng-container>
